var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clock"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.time),expression:"time"}]},[_vm._v("UK time "+_vm._s(_vm.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }